import { ProductCardProps } from "@/components/ProductCard";
import Text from "@/components/Text";
import { SEGMENTOS_POS } from "@/api/products";
import { formatPrice } from "@/utils/currency";
import CompositionPlan from "@/components/CompostionPlan";
import Price from "@/components/Price";
import Button from "@/components/Button";
import AppBenefits from "@/components/AppBenefits";

interface MobileHeaderProps extends ProductCardProps {
  showAppBenefits: boolean;
}

export default function MobileHeader({
  product,
  onSelect,
  to,
  showAppBenefits,
}: MobileHeaderProps) {
  const ddd = import.meta.env.VITE_DDD_DEFAULT_PLANS;
  const price = product.precos.find((p) => p.ddd === ddd);

  const isPos = SEGMENTOS_POS.includes(product.segmento);

  const actualPriceFormatted = formatPrice(price?.preco_atual || 0);
  const actualPrice = price?.preco_atual || 0;

  const fidelity = product.fidelidades?.find((f) =>
    f.precos.some((p) => p.ddd === ddd)
  );
  const fidelityPrice = product.fidelidades
    ?.find((f) => f.precos.some((p) => p.ddd === ddd))
    ?.precos.find((p) => p.ddd === ddd)?.preco_atual;

  const actualFidelityPrice =
    Math.round((actualPrice + (fidelityPrice || 0)) * 100) / 100;
  return (
    <>
      <div className="flex items-center justify-between text-tim-primary">
        <section>
          <Text
            as="h3"
            size="4xl"
            className="font-semibold uppercase leading-none tracking-wide"
          >
            {product.gb}GB
          </Text>
        </section>
        <section>
          <CompositionPlan
            showTitle={false}
            gbPadrao={product.gbPadrao}
            gbPromocional={product.gbPromocional}
            gbBonusPortabilidade={product.gbBonusPortabilidade}
            mostrarPortabilidade={product?.mostrarPortabilidade}
            gbBonusDedicado={product?.gbBonusDedicated}
            mostrarDedicado={product?.mostrarDedicado}
            isPos={isPos}
          />
        </section>
      </div>
      <div className="flex items-center justify-between text-tim-primary">
        <section>
          <div className="text-center text-sm text-gray-400 ">
            {actualFidelityPrice < actualPrice && (
              <>
                <span className="line-through">
                  de R$ {actualPriceFormatted}{" "}
                </span>{" "}
                por
              </>
            )}
          </div>

          <div className="items-center text-center font-medium leading-none">
            <Price price={actualFidelityPrice || actualPrice} />
          </div>
        </section>
        <section>
          <Button to={to} onClick={() => onSelect?.(product)}>
            CONTRATAR AGORA
          </Button>
          <div className="px-3 pt-1 text-center text-xs text-gray-400">
            {fidelity && (fidelity.descricao_omega ?? fidelity.descricao)}
          </div>
        </section>
      </div>
      {showAppBenefits && (
        <div className="mt-3 self-center">
          <section>
            <AppBenefits benefits={product.beneficios} />
          </section>
        </div>
      )}
    </>
  );
}
